<template>
    <!-- Call Report List View -->
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <!-- Breadcrumb Section -->
                <div class="breadcrumbnew">
                    <span>Call Reports</span>
                    <!-- <span>Call Reports</span> -->
                    <a>List View</a>
                </div>
                <!-- Header Buttons Section -->
                <div>
                    <form class="form-inline">
                        <div class="d-flex mt-2 flex-wrap">
                            <a href="javascript:;" class="btn btn-new-primary btn-des mr-2 mb-3" :disabled="filter" style="background-color: #B3C7DD !important; cursor: not-allowed !important;color: #8594A4 !important;">
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" height="18px" alt="export"
                                    style="margin-right: 8px; margin-top: -2px;" />
                                Export to Excel
                            </a>
                            <a v-if="(selectDraftSend.status === 'draft' && draftCallReportList.length != 0) || (selectDraftSend.status === 'sent' && sentCallReportList.length != 0)" href="javascript:;" class="btn btn-new-primary btn-des" style="margin-right: 10px;"
                                @click="showFilter()" >
                                <i class="icon icon-magnify icondefault" style="border-radius: 0; background: transparent;  font-size: 20px;" @click="showFilter()"></i>
                                Search
                            </a>
                            <button v-if="selectDraftSend.status == 'draft' && userPermissions.draft_call_reports.permitted_actions.delete" class="btn btn-des mr-4"
                                :class="draftSelect.length ? 'btn-new-danger' : 'btn-new-grey'"
                                @click.prevent="draftSelect.length ? $modal.show('deleteCallReports') : ''">-
                                Delete</button>
                            <div class="dropdown"  v-if="userPermissions.call_reports.permitted_actions.create || userPermissions.draft_call_reports.permitted_actions.create">
                                <a  :disabled="filter" class="btn btn-new-green btn-wide dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    + Create New
                                </a>
                                <div class="dropdown-menu call-report-type-menu" aria-labelledby="dropdownMenuLink">
                                    <!-- <a class="dropdown-item" v-for="(category, index) in call_report_category_options"
                                        :key="index" v-on:click="createCallReport(category)">{{ category }}</a> -->
                                    <a class="dropdown-item" v-on:click="createCallReport('External Meeting')">External Meeting</a>
                                    <a class="dropdown-item" v-on:click="createCallReport('Internal Meeting')">Internal Meeting</a>
                                    <a class="dropdown-item" v-on:click="createCallReport('Review Meeting')">Review Meeting</a>
                                    <a class="dropdown-item" v-on:click="createCallReport('Sales Meeting')">Sales Meeting</a>
                                    <a class="dropdown-item" v-on:click="createCallReport('Release Notes')">Release Notes</a>
                                </div>
                                
                            </div>
                            <div class=" ml-2 search-layout mb-3" style="border-top: 1px solid #a9aaad !important;border-radius: 12px !important;background-color: #fff !important;">
                                <multiselect  label="name" class="digi-multiselect loaderbg callreporttype" placeholder="Select" :disabled="filter"
                                    :clearable="false" name="meetingcall" @select="changedCallReportStatus"
                                    v-model="selectDraftSend" :options="report_dropdown" style="width: 130px !important;" @open="showData"
                                    :taggable="false" :show-labels="false" :searchable="false" :allow-empty="false" :block-keys="['Delete']">
                                </multiselect>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- Filtered Chips Section -->
            <div class="table-block pt-0" v-if="showfilterData.author_name.length ||  showfilterData.receiver_name.length ||showfilterData.receiver_type.length ||  showfilterData.call_report_category.length  ||  showfilterData.location.length || showfilterData.meeting_type.length || showfilterData.title_name.length || showfilterData.created_date">
                <div class="filterSelectedChips mb-3">
                    <div class="pull-right pointer resetChips" style="bottom: 7px !important;" @click="resetFilters()"><i class="icon icon-close text-white fs-20"></i></div>
                    <div class="d-flex align-items-center flex-wrap">
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.author_name.length">Author Name</span>
                        <span v-for="(name,sf_index) in showfilterData.author_name" :key="sf_index">
                            <span class="filterChips" @click="removeData(name,'author_name')">
                                {{name.full_name ? name.full_name : name}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.call_report_category.length">Call Report Type</span>
                        <span v-for="(call_report_category,product_index) in showfilterData.call_report_category" :key="product_index">
                            <span class="filterChips" @click="removeData(call_report_category,'call_report_category')">
                                {{call_report_category}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.receiver_name.length">Receiver</span>
                        <span v-for="(receiver,receiver_index) in showfilterData.receiver_name" :key="receiver_index">
                            <span class="filterChips text-capitalize" @click="removeData(receiver,'receiver')">
                                {{receiver.full_name+ " " +receiver.company_name ? receiver.company_name : ''}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.receiver_type.length">Receiver Type</span>
                        <span class="filterChips text-capitalize" v-if="showfilterData.receiver_type" @click="removeData(receiver_type,'receiver_type')">
                            {{showfilterData.receiver_type}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.location.length">Location</span>
                        <span v-for="(location,location_index) in showfilterData.location" :key="location_index">
                            <span class="filterChips text-capitalize" @click="removeData(location,'location')">
                                {{location}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.meeting_type.length">Meeting Type</span>
                        <span v-for="(meeting_type,meeting_type_index) in showfilterData.meeting_type" :key="meeting_type_index">
                            <span class="filterChips text-capitalize" @click="removeData(meeting_type,'meeting_type')">
                                {{meeting_type}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.title_name.length">Title Name</span>
                        <span v-for="(title_name,title_name_index) in showfilterData.title_name" :key="title_name_index">
                            <span class="filterChips text-capitalize" @click="removeData(title_name,'title_name')">
                                {{title_name}}
                                <i class="icon icon-close fs-12"></i>
                            </span>
                        </span>
                        <span class="font-weight-bold text-white p-2" v-show="showfilterData.created_date">Created Date</span>
                        <span class="filterChips" v-if="showfilterData.created_date" @click="removeCreatedDate()">
                            Date Range: {{convertViewCall(showfilterData.created_date.created_date.start_date)}}, End Date: {{convertViewCall(showfilterData.created_date.created_date.end_date)}}
                            <i class="icon icon-close fs-12"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="design-block">
                <h2 class="headerblock pt-1">
                    <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="d-flex align-items-center">
                            <form class="form-inline">
                               
                            </form>
                        </div>
                        <!-- Pagination Section -->
                        <div class="d-flex align-items-center">
                            <form class="form-inline pull-right">
                                <div v-if="selectDraftSend.status === 'draft' && selectDraftSend.status !== 'sent'" >
                                    <div v-if="(selectDraftSend.status === 'draft' && draftCallReportList.length != 0) || (selectDraftSend.status === 'sent' && sentCallReportList.length != 0)" class="pagination-footer d-flex align-items-center" style="margin-top: 2px;">
                                        <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow" :options="pageLimit" :close-on-select="true" v-model.number="limit" :max-height="210" open-direction="bottom" :show-labels="false" :searchable="false" :allow-empty="false" :block-keys="['Delete']" placeholder="" style="width: 4.2em !important;padding-right: 10px!important;">
                                        </multiselect>
                                        <span class="page-info pr-2 pl-6 fw-600" style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 14px;">Per page</span>
                                        <span class="page-info px-2 fw-600"
                                            style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 14px;">{{getDraftSkipCount}} - {{draft_total>skip+limit?skip+limit:draft_total}} of {{draft_total}}</span>
                                        <button type="button" class="btn btn-icon" id="previous"
                                            style="padding: 4px 1.8px 0.8rem 2px;"
                                            @click="previousPageDraft()">
                                            <el-tooltip class="item" effect="dark" content="Previous" placement="top">
                                                <i class="icon icon-chevron-left"
                                                    style="color: #4e5764 !important;"></i>
                                            </el-tooltip>
                                        </button>
                                        <button type="button" class="btn btn-icon" id="next"
                                            style="padding-left:1.8px;padding-top: 4px;"
                                            @click="nextPageDraft()">
                                            <el-tooltip class="item" effect="dark" content="Next" placement="top">
                                                <i class="icon icon-chevron-right"
                                                    style="color: #4e5764 !important;"></i>
                                            </el-tooltip>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </h2>
                <div style="width:100%;" class="mb-5 callreportlist">
                    <div class="page-layout carded left-sidebar"
                        style="border: 0px solid rgb(148, 190, 240) !important;border-radius: 0px !important;">
                        <div class="page-content-wrapper" style="overflow-x:auto">
                            <div class="page-content">
                                <!-- Table view Section -->
                                <div class="demo-content">
                                    <table class="table table-new-template table-brand">
                                        <thead v-if="(selectDraftSend.status === 'draft' && draftCallReportList.length != 0) || (selectDraftSend.status === 'sent' && sentCallReportList.length != 0)">
                                            <tr>
                                                <th v-if="selectDraftSend.status === 'sent'"></th>
                                                <th v-else>
                                                    <label class="custom-control custom-checkbox digi-checkbox"
                                                        style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                        <input
                                                            v-model="select_all_draft"
                                                            type="checkbox" class="custom-control-input"
                                                            @change="selectAll" />
                                                        <span class="custom-control-indicator"
                                                            style="font-size: 20px;top: -10px !important;color: #fff !important;"></span>
                                                        <span class="form-check-description fw-600"></span>
                                                    </label>
                                                </th>
                                                <th v-if="selectDraftSend.status === 'sent' && userPermissions.call_reports.permitted_actions.clone">
                                                </th>
                                                <th v-else-if="selectDraftSend.status === 'draft' && userPermissions.draft_call_reports.permitted_actions.edit">
                                                </th>
                                                <th v-if="selectDraftSend.status === 'sent'"></th>
                                                <th>REPORT ID</th>
                                                <th>COMPANY NAME</th>
                                                <th>RECEIVER</th>
                                                <th>RECEIVER TYPE</th>
                                                <th>CALL REPORT TYPE</th>
                                                <th>STATUS</th>
                                                <th>TITLE NAME</th>
                                                <th>TIMESTAMP</th>
                                                <th>AUTHOR</th>
                                                <!-- <th v-for="(heading,index) in columnConifg" :key="index"
                                                    :track-by="heading.order">{{ heading.value.toUpperCase()  }}</th> -->
                                            </tr>
                                        </thead>
                                        <tbody v-if="selectDraftSend.status === 'sent'">
                                            <tr v-if="ajaxCallinprogress && sentCallReportList.length <=0">
                                                <td colspan="13">
                                                    <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallinprogress">
                                                        <half-circle-spinner :animation-duration="1000" :size="60"  color="#00448b" style="margin: 0 auto;" />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-else-if="!ajaxCallinprogress && sentCallReportList.length <= 0" class="text-center font-weight-bold" style="height: 400px !important; background-color: #fff !important;">
                                                <td colspan="13">
                                                    <img src="/static/images/contact-list.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                                    <div class="text-center"> No Completed Call Report added!</div>
                                                </td>
                                            </tr>
                                            <tr v-else v-for="(callreport,index) in sentCallReportList" :key="index"
                                                :track-by="callreport.order" class="sent-call-tr" >
                                                <td>
                                                    <div class="pointer">
                                                        <el-tooltip class="item" effect="dark" content="View"
                                                            placement="top">
                                                            <button class="btn-icon pt-3 pointer"
                                                                @click="viewSendCallReport(callreport._id)"
                                                                style="padding:0px!important;">
                                                                <i class="icon icon-eye eyeIcon item text-dark iconsize-18"
                                                                    style="margin-right: 13px;"></i>
                                                            </button>
                                                        </el-tooltip>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="pointer" v-if="callreport.edit_permission">
                                                        <el-tooltip class="item" effect="dark" content="Permissions"
                                                            placement="top">
                                                             <span class="el-dropdown-link d-flex justify-content-between w-100" @click="showsendList(callreport._id)">
                                                                <img src="/static/images/images-new-theme/icons/send_all_icon.png" height="15px;" >
                                                            </span>
                                                        </el-tooltip>
                                                    </div>
                                                </td>
                                                <td v-if="userPermissions.call_reports.permitted_actions.clone">
                                                    <div class="pointer">
                                                        <el-tooltip class="item" effect="dark" content="Copy"
                                                            placement="top">
                                                            <button class="btn-icon pt-3 pointer" style="padding:0px!important;"
                                                                @click="copyCallReport(callreport._id)">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/copy-yellow.svg"
                                                                    height="15px;">
                                                            </button>
                                                        </el-tooltip>
                                                    </div>
                                                </td>
                                                <td :title="callreport.call_report_number.value || '-'" @click="viewSendCallReport(callreport._id)" >
                                                    <span
                                                        style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;">
                                                        {{callreport.call_report_number.value}}
                                                    </span>
                                                </td>
                                                <td v-if="callreport.call_report_type.value == 'External Meeting' || callreport.call_report_type.value == 'Sales Meeting' || callreport.call_report_type.value == 'Release Notes'" @click="viewSendCallReport(callreport._id)">
                                                    <template v-for="(receiver,company_index) in callreport.receiver_company_details" >
                                                        <div v-if="receiver.length >= 1" class="d-flex align-items-center" :key="company_index+receiver" >
                                                            <span class="text-capitalize text-truncate" style="max-width: 200px;" :title="receiver[0]">{{receiver[0] || "-"}}</span>
                                                            <br/>
                                                            <el-popover
                                                                v-if="receiver.length > 1"
                                                                placement="bottom"
                                                                trigger="hover">
                                                                <div>
                                                                    <span class="fw-500">{{receiver.join(", ")}}</span>
                                                                </div>
                                                                <el-button slot="reference" class="pl-0 pr-0 odd-even">
                                                                    <div class="fw-500 mt-4px text-center text-secondary">
                                                                        +{{receiver.length - 1}} more
                                                                    </div>
                                                                </el-button>
                                                            </el-popover>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td v-else @click="viewSendCallReport(callreport._id)"> {{'-'}}</td>
                                                <td v-if="callreport.call_report_type.value == 'External Meeting' || callreport.call_report_type.value == 'Sales Meeting' || callreport.call_report_type.value == 'Release Notes'" @click="viewSendCallReport(callreport._id)">
                                                    <template v-for="(receiver,index) in callreport.receiver_details" >
                                                        <div v-if="receiver.length >= 1" class="d-flex align-items-center" :key="index+receiver" >
                                                            <span v-if="receiver.length >= 1" class="text-capitalize text-truncate"  style="max-width: 200px;" :title="receiver[0]">{{receiver[0]}}</span>
                                                            <span v-else class="text-capitalize">{{"-"}}</span>
                                                            <br/>
                                                            <el-popover
                                                                v-if="receiver.length > 1"
                                                                placement="bottom"
                                                                trigger="hover">
                                                                <div>
                                                                    <span class="fw-500">{{receiver.join(", ")}}</span>
                                                                </div>
                                                                <el-button slot="reference" class="pl-0 pr-0 odd-even">
                                                                    <div class="fw-500 mt-4px text-center text-secondary">
                                                                        +{{receiver.length - 1}} more
                                                                    </div>
                                                                </el-button>
                                                            </el-popover>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td v-else @click="viewSendCallReport(callreport._id)"> {{'-'}}</td>
                                                <td v-if="callreport.call_report_type.value == 'External Meeting' || callreport.call_report_type.value == 'Sales Meeting' || callreport.call_report_type.value == 'Release Notes'" @click="viewSendCallReport(callreport._id)">
                                                    <span
                                                        style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;">
                                                        {{callreport.receiver_type.value}}
                                                    </span>
                                                </td>
                                                <td v-else @click="viewSendCallReport(callreport._id)"> {{'-'}}</td>
                                                <td :title="callreport.call_report_type.value || '-'" @click="viewSendCallReport(callreport._id)">{{callreport.call_report_type.value}}</td>
                                                <td @click="viewSendCallReport(callreport._id)">
                                                    <template v-for="(status,index) in callreport.status">
                                                        <div v-if="status.length >= 1" class="d-flex align-items-center" :key="index+status">
                                                            <span>{{status[0]}}</span>
                                                            <br />
                                                            <el-popover
                                                                v-if="status.length > 1"
                                                                placement="bottom"
                                                                trigger="hover">
                                                                <div>
                                                                    <span class="fw-500">{{status.join(", ")}}</span>
                                                                </div>
                                                                <el-button slot="reference" class="pl-0 pr-0 odd-even">
                                                                    <div class="fw-500 mt-4px text-center text-secondary">
                                                                        +{{status.length - 1}} more
                                                                    </div>
                                                                </el-button>
                                                            </el-popover>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td :title="callreport.title_name.value || '-'" @click="viewSendCallReport(callreport._id)">
                                                    <span class="text-capitalize"
                                                        style="max-width: 150px; white-space: nowrap; overflow: hidden;  text-overflow: ellipsis; display: block;">
                                                        {{callreport.title_name.value}}
                                                    </span>
                                                </td>
                                                <td @click="viewSendCallReport(callreport._id)">{{callreport.timestamp.value || "-"}}
                                                </td>
                                                <td :title="callreport.author.value || '-'" @click="viewSendCallReport(callreport._id)">
                                                    <span
                                                        style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;">
                                                        {{callreport.author.value}}
                                                    </span>
                                                </td>
                                            </tr>
                                            <!-- <template v-if="showCallReport && !ajaxCallinprogress && sentCallReportList.length == 0">
                                                <tr v-if="!ajaxCallinprogress && sentCallReportList.length == 0" class="text-center font-weight-bold">
                                                    <td colspan="13"></td>
                                                </tr>
                                                <tr v-if="!ajaxCallinprogress && sentCallReportList.length == 0" class="text-center font-weight-bold" style="height: 400px !important; background-color: #fff !important;">
                                                    <td colspan="13">
                                                        <img src="/static/images/contact-list.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                                        <div class="text-center"> No Completed Call Report added!</div>
                                                    </td>
                                                </tr>
                                            </template> -->
                                        </tbody>
                                        <tbody v-if="selectDraftSend.status === 'draft'">
                                            <tr v-if="ajaxCallinprogress">
                                                <td colspan="13">
                                                    <div class="d-flex align-items-center justify-content-center h-100">
                                                        <half-circle-spinner :animation-duration="1000" :size="60"
                                                            color="#00448b" style="margin: 0 auto;" />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-else-if="!ajaxCallinprogress && draftCallReportList.length == 0" style="height: 400px !important; background-color: #fff !important;">
                                                <td colspan="15">
                                                    <div style="width:100%;" class="mt-5 mb-5 text-center">
                                                        <img src="/static/images/contact-list.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                                        <div class="text-center"> No Draft Call Report added!</div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-else v-for="(draftcallreport,index) in draftCallReportList" :key="index"
                                                :track-by="draftcallreport.order" class="tr-draft" >
                                                <td>
                                                    <label class="custom-control custom-checkbox digi-checkbox"
                                                        style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                        <input v-model="draftcallreport.checked"
                                                            type="checkbox" class="custom-control-input"
                                                            @change="draftSelected($event, draftcallreport, index)" />
                                                        <span class="custom-control-indicator"
                                                            style="font-size: 20px;top: -10px !important;"
                                                            :style="index%2 === 0 ? '' : 'color: #969595 !important;'"></span>
                                                        <span class="form-check-description fw-600"></span>
                                                    </label>
                                                </td>
                                                <td v-if="userPermissions.draft_call_reports.permitted_actions.edit" @click="editDraftCallReport(draftcallreport._id)">
                                                    <div class="pointer" >
                                                        <el-tooltip class="item" effect="dark" content="Edit"
                                                            placement="top">
                                                            <button class="btn-icon pt-3 pointer"
                                                                @click="editDraftCallReport(draftcallreport._id)"
                                                                style="padding:0px!important;">
                                                                <img :src="index%2 === 0 ? '/static/images/images-new-theme/icons/edit.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/edit-grey.svg'"
                                                                    height="15px;">
                                                            </button>
                                                        </el-tooltip>
                                                    </div>
                                                </td>
                                                <td :title="draftcallreport.call_report_number.value || '-'" @click="editDraftCallReport(draftcallreport._id)" class="text-center">
                                                    <span
                                                        style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;">
                                                        {{draftcallreport.call_report_number.value}}
                                                    </span>
                                                </td>
                                                <td v-if="draftcallreport.call_report_type.value == 'External Meeting' || draftcallreport.call_report_type.value == 'Sales Meeting' || draftcallreport.call_report_type.value == 'Release Notes'" @click="editDraftCallReport(draftcallreport._id)">
                                                    <template v-for="(receiver,draft_comp_index) in draftcallreport.receiver_company_details" >
                                                        <div class="d-flex align-items-center" :key="draft_comp_index+receiver" v-if="receiver.length >= 1">
                                                            <span class="text-capitalize text-truncate" style="max-width: 200px;">{{receiver[0]}}</span><br />
                                                            <el-popover
                                                                v-if="receiver.length > 1"
                                                                placement="bottom"
                                                                trigger="hover">
                                                                <div>
                                                                    <span class="fw-500">{{receiver.join(", ")}}</span>
                                                                </div>
                                                                <el-button slot="reference" class="pl-0 pr-0 odd-even">
                                                                    <div class="fw-500 mt-4px text-center text-secondary">
                                                                        +{{receiver.length - 1}} more
                                                                    </div>
                                                                </el-button>
                                                            </el-popover>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td v-else @click="editDraftCallReport(draftcallreport._id)"> {{'-'}}</td>
                                                <td v-if="draftcallreport.call_report_type.value == 'External Meeting' || draftcallreport.call_report_type.value == 'Sales Meeting' || draftcallreport.call_report_type.value == 'Release Notes'" @click="editDraftCallReport(draftcallreport._id)">
                                                    <template v-for="(receiver,index) in draftcallreport.receiver_details" >
                                                        <div class="d-flex align-items-center" :key="index+receiver" v-if="receiver.length >= 1">
                                                            <span class="text-capitalize text-truncate" style="max-width: 200px;" :title="receiver[0]">{{receiver[0]}}</span><br />
                                                            <el-popover
                                                                v-if="receiver.length > 1"
                                                                placement="bottom"
                                                                trigger="hover">
                                                                <div>
                                                                    <span class="fw-500">{{receiver.join(", ")}}</span>
                                                                </div>
                                                                <el-button slot="reference" class="pl-0 pr-0 odd-even">
                                                                    <div class="fw-500 mt-4px text-center text-secondary">
                                                                        +{{receiver.length - 1}} more
                                                                    </div>
                                                                </el-button>
                                                            </el-popover>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td v-else @click="editDraftCallReport(draftcallreport._id)"> {{'-'}}</td>
                                                <td v-if="draftcallreport.call_report_type.value == 'External Meeting' || draftcallreport.call_report_type.value == 'Sales Meeting' || draftcallreport.call_report_type.value == 'Release Notes'" @click="editDraftCallReport(draftcallreport._id)">
                                                    <span
                                                        style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;">
                                                    {{draftcallreport.receiver_type.value}}
                                                    </span>
                                                </td>
                                                <td v-else @click="editDraftCallReport(draftcallreport._id)"> {{'-'}}</td>
                                                <td :title="draftcallreport.call_report_type.value || '-'" @click="editDraftCallReport(draftcallreport._id)">{{draftcallreport.call_report_type.value}}</td>
                                                <td @click="editDraftCallReport(draftcallreport._id)">
                                                    <template v-for="(status,index) in draftcallreport.status">
                                                        <div v-if="status.length >= 1" class="d-flex align-items-center" :key="index+status">

                                                        <span>{{status[0]}}</span>
                                                        <br />
                                                        <el-popover
                                                            v-if="status.length > 1"
                                                            placement="bottom"
                                                            trigger="hover">
                                                            <div >
                                                                <span class="fw-500">{{status.join(",")}}</span>
                                                            </div>
                                                            <el-button slot="reference" class="pl-0 pr-0 odd-even">
                                                                <div class="fw-500 mt-4px text-center text-secondary">
                                                                    +{{status.length - 1}} more
                                                                </div>
                                                            </el-button>
                                                        </el-popover>
                                                    </div>
                                                    </template>
                                                </td>

                                                <td :title="draftcallreport.title_name.value || '-'" @click="editDraftCallReport(draftcallreport._id)">
                                                    <span class="text-capitalize"
                                                        style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;">
                                                        {{draftcallreport.title_name.value}}
                                                    </span>
                                                </td>
                                                <td @click="editDraftCallReport(draftcallreport._id)">{{draftcallreport.timestamp.value || "-"}}
                                                </td>
                                                <td :title="draftcallreport.author.value || '-'" @click="editDraftCallReport(draftcallreport._id)">
                                                    <span
                                                        style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;">
                                                        {{draftcallreport.author.value}}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Pagination Section -->
                    <div v-if="selectDraftSend.status === 'sent' && selectDraftSend.status !== 'draft'" class="d-flex justify-content-end align-items-center bg-white pt-2">
                        <div v-if="(selectDraftSend.status === 'draft' && draftCallReportList.length != 0) || (selectDraftSend.status === 'sent' && sentCallReportList.length != 0)" class="pagination-footer d-flex align-items-center" style="margin-top: 2px;">
                        <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow" :options="pageLimit" :close-on-select="true" v-model.number="limit" :max-height="210" open-direction="top" :show-labels="false"  :searchable="false" :allow-empty="false" :block-keys="['Delete']" placeholder="" style="width: 4.2em !important;padding-right: 10px!important;">
                        </multiselect>
                        <span class="page-info pr-2 pl-6 fw-600" style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 14px;">Per page</span>
                            <span class="page-info px-2 fw-600"
                                style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 14px;">{{getSkipCount}} - {{sent_total>skip+limit?skip+limit:sent_total}} of {{sent_total}}</span>
                            <button type="button" class="btn btn-icon" id="previous"
                                style="padding: 4px 1.8px 0.8rem 2px;" @click="previousPageSent()" :class="skip == 0 ? 'not-allowed' : 'pointer'">
                                <el-tooltip class="item" effect="dark" content="Previous" placement="top">
                                    <i class="icon icon-chevron-left"
                                        style="color: #4e5764 !important;"></i>
                                </el-tooltip>
                            </button>
                            <button type="button" class="btn btn-icon" id="next" :class="skip_temp >= sent_total ? 'not-allowed' : 'pointer'"
                                style="padding-left:1.8px;padding-top: 4px;" @click="nextPageSent()">
                                <el-tooltip class="item" effect="dark" content="Next" placement="top">
                                    <i class="icon icon-chevron-right"
                                        style="color: #4e5764 !important;"></i>
                                </el-tooltip>
                            </button>
                        </div>
                    </div>
                </div>
                <column-config modal_name="columnConfig" @coloumnUpdate="columnCallReportList"></column-config>
            </div>
        </div>
        <!-- Search Filter Section -->
        <div>
            <div class="filter-div-absolute filter-height filter-place filterblock" v-if="filter">
                <div class="d-flex justify-content-between align-items-center px-2"
                    style="background: #00448b; border-radius: 7.5px 7.5px 0px 0px; padding:10px;">
                    <span class="ml-auto mr-auto fs-16" style="font-weight: 600; color: #fff;">
                        Search Call Reports
                    </span>
                   <span class="d-flex align-items-center">
                        <div @click="closeFilters" class="pointer">
                            <i class="icon icon-close" style="color: white; margin: 10px 10px 0px 0px;"></i>
                        </div>
                    </span>
                </div>
                <div style="background: #FFF; border-radius: 0px 0px 7.5px 7.5px;">
                    <div style="overflow-x: hidden; overflow-y: auto;">
                        <div class="p-4 filtercontentblock" style="height: 260px !important;">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                <h6>Author</h6>
                                    <multiselect :max-height="200" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow"
                                        :limit="1" :limit-text="limitAuthor" :loading="isLoading.author" @open="fetchAuthor"
                                        v-model="author_names_selected" label="full_name" track-by="id"
                                        :blockKeys="['Delete']" placeholder="Type to Search" @search-change="SearchAuthorDetails"
                                        :options="author_name_options" :multiple="true" :searchable="true" :internal-search="true"
                                        :clear-on-select="false" :close-on-select="false" :options-limit="2040"
                                        :show-no-results="true" :hide-selected="false" >
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag">
                                                <span class="filterSelectedName">{{ option.full_name }}</span>
                                                    <span class="custom__remove pointer" @click="removeAuthor(option)">
                                                    <i class="icon icon-close fs-16 text-white"></i>
                                                    </span>
                                                </span>
                                            </template>
                                            <template slot="afterList">
                                                <div
                                                    v-observe-visibility="getMoreAuthorDetails" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Authors Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <h6>Title Name</h6>
                                    <multiselect v-if="selectDraftSend.status === 'sent'" :max-height="150" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow"
                                        :searchable="true" placeholder="Type to Search" :options="title_name_options"
                                        v-model="title_name_selected" :loading="isLoading.title" :multiple="true"
                                        :taggable="false" :close-on-select="true" :show-labels="false" :clear-on-select="false"
                                        open-direction="bottom"  @open="fetchTitleName" @search-change="SearchTitleName"
                                        >
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag">
                                                    <span class="filterSelectedName">{{ option }}</span>
                                                    <span class="custom__remove pointer" @click="removeTitleName(option)">
                                                    <i class="icon icon-close fs-16 text-white"></i>
                                                    </span>
                                                </span>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Title Names Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                    </multiselect>
                                    <multiselect v-else :max-height="150" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow"
                                        :searchable="true" placeholder="Type to Search" :options="title_name_options"
                                        v-model="title_name_selected" :loading="isLoading.title" :multiple="true"
                                        :taggable="false" :close-on-select="true" :show-labels="false" :clear-on-select="false"
                                        open-direction="bottom"  @open="fetchDraftTitleName" @search-change="SearchDraftTitleName"
                                        >
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag">
                                                    <span class="filterSelectedName">{{ option }}</span>
                                                    <span class="custom__remove pointer" @click="removeTitleName(option)">
                                                    <i class="icon icon-close fs-16 text-white"></i>
                                                    </span>
                                                </span>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Title Names Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                    </multiselect>
                                </div>
                            
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <h6>Call Report Type</h6>
                                    <multiselect :max-height="150" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow fs-14 fw-600"
                                        :searchable="true" placeholder="Type to Search" :options="call_report_category_options" :loading="reportListLoading"
                                        v-model="call_report_category_selected" :multiple="true" :taggable="false" @open="getCallReportType"
                                        :close-on-select="true"  :show-labels="false" :clear-on-select="false"
                                        open-direction="bottom">
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag">
                                                    <span class="filterSelectedName">{{ option }}</span>
                                                    <span class="custom__remove pointer" @click="removeCallReportType(option)">
                                                    <i class="icon icon-close fs-16 text-white"></i>
                                                    </span>
                                                </span>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Call Report Types Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <h6>Meeting Type</h6>
                                    <multiselect :max-height="150" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow"
                                        :searchable="true"  placeholder="Type to Search"
                                        :options="['Chat', 'Email', 'In Person', 'Audio Call', 'Video Call']"
                                        v-model="meeting_type_selected" :multiple="true" :taggable="false"
                                        :close-on-select="true" :show-labels="false" :clear-on-select="false"
                                        open-direction="bottom">
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag">
                                                    <span class="filterSelectedName">{{ option }}</span>
                                                    <span class="custom__remove pointer" @click="removeMeetingType(option)">
                                                    <i class="icon icon-close fs-16 text-white"></i>
                                                    </span>
                                                </span>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Meeting Types Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <h6>Receiver Type</h6>
                                    <multiselect :max-height="150" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow"
                                        :searchable="true"  placeholder="Type to Search" :options="['Contact','Customer','Lead', 'Vendor']"
                                        v-model="receiver_type_selected" :multiple="false"  :taggable="false" @select="typeSelected"
                                        :close-on-select="true" :show-labels="false" :clear-on-select="false"
                                        open-direction="bottom">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                                <span class="filterSelectedName">{{ option }}</span>
                                                <span class="custom__remove pointer" >
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Receiver Type Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <h6>Receiver</h6>
                                    <multiselect :max-height="150" v-if="receiver_type_selected == 'Contact'" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow" :disabled="!receiver_type_selected.length"
                                        :searchable="true" placeholder="Type to Search" label="full_name" track-by="id" :options="receiver_name_options"
                                        v-model="receiver_name_selected" :limit="1" :limit-text="limitAuthor" :multiple="true" :loading="receiver_loading" @search-change="searchContactNameByKey" @open="searchContactName()"
                                        :close-on-select="false" :clear-on-select="false" :show-no-results="true"
                                        open-direction="bottom" >
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                                <span class="filterSelectedName">{{ option.full_name }}</span>
                                                <span class="custom__remove pointer" @click="removeReceiverName(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Company Names Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfContactName" />
                                        </template>

                                    </multiselect>
                                    <multiselect v-else-if="receiver_type_selected == 'Customer'" :max-height="150" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow" :disabled="!receiver_type_selected.length"
                                        :searchable="true" placeholder="Type to Search" label="full_name" track-by="id" :options="receiver_name_options"
                                        v-model="receiver_name_selected" :multiple="true" :loading="receiver_loading"
                                        :close-on-select="false" :limit="1" :limit-text="limitAuthor" :clear-on-select="false"
                                        open-direction="bottom"  @search-change="searchCustomerByKey" @open="searchCustomer()">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                                <span class="filterSelectedName">{{ option.full_name }}</span>
                                                <span class="custom__remove pointer" @click="removeReceiverName(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Customer Names Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                        <template slot="afterList" >
                                            <div v-observe-visibility="reachedEndOfCustomers" />
                                        </template>

                                    </multiselect>
                                    <multiselect v-else-if="receiver_type_selected == 'Vendor'" :max-height="120" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow" :disabled="!receiver_type_selected.length"
                                        :searchable="true" placeholder="Type to Search" label="full_name" track-by="id" :options="receiver_name_options"
                                        v-model="receiver_name_selected" :limit="1" :limit-text="limitAuthor" :multiple="true" :loading="receiver_loading"
                                        :close-on-select="false" :clear-on-select="false"
                                        open-direction="bottom"  @search-change="searchVendorList" @open="searchVendorName()">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                                <span class="filterSelectedName">{{ option.full_name }}</span>
                                                <span class="custom__remove pointer" @click="removeReceiverName(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Vendor Names Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                        <template slot="afterList" >
                                            <div v-observe-visibility="reachedEndOfVendors" />
                                        </template>

                                    </multiselect>
                                    <multiselect v-else :max-height="150" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow" :disabled="!receiver_type_selected.length"
                                        :searchable="true" placeholder="Type to Search" label="full_name" track-by="id" :options="receiver_name_options"
                                        v-model="receiver_name_selected" :multiple="true" :loading="receiver_loading"
                                        :close-on-select="false" :limit="1" :limit-text="limitAuthor" :clear-on-select="false" @search-change="searchLeadNameByKey" @open="searchLeadName()"
                                        open-direction="bottom"  :custom-label="customLabel">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                                <span class="filterSelectedName">{{ option.full_name || option.company_name }}</span>
                                                <span class="custom__remove pointer" @click="removeReceiverName(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc"><span class="option__title">{{ props.option.full_name }}</span><span class="option__small">{{ props.option.company_name }}</span></div>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Lead Names Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfLeadName" />
                                        </template>
                                    </multiselect>
                                </div>
                            
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <h6>Location</h6>
                                    <multiselect :max-height="150" class="digi-multiselect loaderbgwhite filter-multiple no-default-icon down-arrow"
                                        :searchable="true" placeholder="Type to Search" :options="countries" openDirection="top"
                                        v-model="location_selected" :limit="1" :limit-text="limitAuthor" :multiple="true" :taggable="false" :close-on-select="true"
                                        :show-labels="false" :clear-on-select="false" open-direction="bottom">
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag">
                                                    <span class="filterSelectedName">{{ option }}</span>
                                                    <span class="custom__remove pointer" @click="removeLocation(option)">
                                                    <i class="icon icon-close fs-16 text-white"></i>
                                                    </span>
                                                </span>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Location Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <h6>Date Range</h6>
                                    <div v-if="dateRange.length" style="border-bottom: 1px solid #a9aaad;">
                                        <div class="d-flex justify-content-between align-items-center"
                                            style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                            <input type="text" placeholder="Select Date Range"
                                                :value="('0'+(new Date(dateRange[0]).getMonth()+1)).slice(-2)+'/'+('0'+(new Date(dateRange[0]).getDate())).slice(-2)+'/'+new Date(dateRange[0]).getFullYear()+' to '+('0'+(new Date(dateRange[1]).getMonth()+1)).slice(-2)+'/'+('0'+(new Date(dateRange[1]).getDate())).slice(-2)+'/'+new Date(dateRange[1]).getFullYear()"
                                                style="color: #fff; background: #41b883; width: 14em;" disabled />
                                            <span @click="dateRange = []"
                                                style="color: #fff; cursor: pointer;">&#10005;</span>
                                        </div>
                                    </div>
                                    <date-picker v-else  v-model="dateRange" format="MM/DD/YYYY" :first-day-of-week="7" range
                                        class="date-width callreport-listdate calendar-edit-per" :show-second="false" :lang="lang"
                                        :clearable="true" confirm :not-after="new Date()" confirm-text="APPLY" type="date">
                                    </date-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-end mt-2 pb-5">
                        <button class="btn btn-des btn-style mr-4 pointer" @click="resetFilters" :disabled="!totalFilters > 0">Reset</button>
                        <button class="btn btn-des btn-style mr-4 text-blue" :disabled="!totalFilters > 0" @click="filter = false, uncheckSelected(), selectDraftSend.status =='sent' ? getCallReportList('init') : getDraftCallReportList('init')">Search</button>
                    </div>
                </div>
            </div>
        </div>
        <manual-send-modal modal_name="manualSendModal" v-if="showManualModal" @hideSendModal="hideSendModal" :data_id="data_id"></manual-send-modal>
        <delete-call-reports modal_name="deleteCallReports" @callReportDelete="deleteDraft"></delete-call-reports>
    </div>
</template>
<style scoped>
    .dropdown-style {
        color:#000 !important;
        text-decoration:none!important;
    }
    .btn-style{
        border: 1px solid #fff;
        background-color: #fff;
    }
    .call-report-dropdown {
		left: 1104px !important;
	}
    @media (min-width:1350px) and (max-width: 1400px) {
        .call-report-dropdown {
           left: 1104px !important;
        }
    }
    .callreport-manage-info {
        font-size: 12px;
        color: rgb(48, 48, 49);
        font-weight: 600;
        padding: 5px 10px;
        text-align: center;
        border: 2px solid #00448b;
        border-radius: 18px;
        background-color: rgb(255, 255, 255);
        top: 13px;
        left: 0px;
        right: 0px;
        margin-left: auto;
        margin-right: auto;
        width: 205px;
        position: relative;
        z-index: 9;
        text-transform: uppercase;
    }
    .odd-even{
        background:transparent !important;
        border: 1px solid transparent !important;
    }
    .callreportlist .page-content {
        background-color: transparent !important;
    }
    .filter-div-absolute {
        width: 850px;
        max-width: 850px;
        /* overflow: scroll !important; */
    }
    .filter-place{
        top: 12.0em !important;
        right: 1.2em !important;
    }
    .filter-height{
        max-height: 450px;
        height: 350px;
        /* overflow: scroll !important; */
        background: #fff;
    }
    .search-layout{
        border-top: 1px solid #a9aaad !important;
        border-left: 1px solid #a9aaad !important;
        border-right: 1px solid #a9aaad !important;
        border-radius: 12px !important;
        padding-left: 5px;
        padding-right: 5px;
    }

</style>

<script>
    import moment from "moment";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import callreport from "./mixins/callreport";
    //import ColumnConfig from "./ColumnConfig";
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import convert from './mixins/convert'
    import countries from "./json/countries.json";
    import DeleteCallReports from "./alertModals/DeleteCallReports";
    import customer from './mixins/customer';
    import leads from './mixins/leads';
    import user_permission from './mixins/user_permission';
    import globals from './globals';
    import contacts from "./mixins/contacts"
    import ManualSendModal from "./ManualSendModal";
    import { debounce } from 'lodash';
    export default {
        data() {
            const value2dateSent = dateRangeSent => {
                const date = new Date(dateRangeSent);
                return dateRangeSent ?
                    new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) :
                    null;
            };
            const date2valueSent = date => {
                return date ?
                    new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) :
                    null;
            };
            const value2dateDraft = dateRangeDraft => {
                const date = new Date(dateRangeDraft);
                return dateRangeSent ?
                    new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) :
                    null;
            };
            return {
                select_all_draft: false,
                pageLimit: [],
                value_create: 0,
                skip_count:0,
                searchKey: '',
                author_skip_count: 0,
                comp_id: '',
                disable_branch_depart: false,
                is_branch_loading: false,
                backToDraft: false,
                valueType: {
                    value2dateSent,
                    date2valueSent,
                    value2dateDraft,
                },
                convertUTC: false,
                startDate: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    new Date().getDate()
                ),
                endDate: new Date(),
                dateRangeSent: [],
                dateRangeDraft: [],
                lang: {
                    type: "en",
                    days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                    months: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                    ],
                    pickers: [
                        "next 7 days",
                        "next 30 days",
                        "previous 7 days",
                        "previous 30 days",
                    ],
                    placeholder: {
                        date: "Select Date",
                        dateRange: "Select Date Range",
                    },
                },
                confirmText: {
                    type: String,
                    default: "APPLY",
                },
                shortcutsSent: [{
                        text: "Today",
                        onClick: () => {
                            this.startDate = new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                new Date().getDate()
                            );
                            this.endDate = new Date();
                            this.dateRangeSent = [
                                this.startDate.setHours(
                                    this.created_time.split(":")[0],
                                    this.created_time.split(":")[1]
                                ),
                                this.endDate,
                            ];
                        },
                    },
                    {
                        text: "This Week",
                        onClick: () => {
                            this.startDate = new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                new Date().getDate() - new Date().getDay()
                            );
                            this.endDate = new Date();
                            this.dateRangeSent = [
                                this.startDate.setHours(
                                    this.created_time.split(":")[0],
                                    this.created_time.split(":")[1]
                                ),
                                this.endDate,
                            ];
                        },
                    },
                    {
                        text: "This Month",
                        onClick: () => {
                            this.startDate = new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                1
                            );
                            this.endDate = new Date();
                            this.dateRangeSent = [
                                this.startDate.setHours(
                                    this.created_time.split(":")[0],
                                    this.created_time.split(":")[1]
                                ),
                                this.endDate,
                            ];
                        },
                    },
                    {
                        text: "This Year",
                        onClick: () => {
                            this.startDate = new Date(new Date().getFullYear(), 0, 1);
                            this.endDate = new Date();
                            this.dateRangeSent = [
                                this.startDate.setHours(
                                    this.created_time.split(":")[0],
                                    this.created_time.split(":")[1]
                                ),
                                this.endDate,
                            ];
                        },
                    },
                ],
                shortcutsDraft: [{
                        text: "Today",
                        onClick: () => {
                            this.startDate = new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                new Date().getDate()
                            );
                            this.endDate = new Date();
                            this.dateRangeDraft = [
                                this.startDate.setHours(
                                    this.created_time.split(":")[0],
                                    this.created_time.split(":")[1]
                                ),
                                this.endDate,
                            ];
                        },
                    },
                    {
                        text: "This Week",
                        onClick: () => {
                            this.startDate = new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                new Date().getDate() - new Date().getDay()
                            );
                            this.endDate = new Date();
                            this.dateRangeDraft = [
                                this.startDate.setHours(
                                    this.created_time.split(":")[0],
                                    this.created_time.split(":")[1]
                                ),
                                this.endDate,
                            ];
                        },
                    },
                    {
                        text: "This Month",
                        onClick: () => {
                            this.startDate = new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                1
                            );
                            this.endDate = new Date();
                            this.dateRangeDraft = [
                                this.startDate.setHours(
                                    this.created_time.split(":")[0],
                                    this.created_time.split(":")[1]
                                ),
                                this.endDate,
                            ];
                        },
                    },
                    {
                        text: "This Year",
                        onClick: () => {
                            this.startDate = new Date(new Date().getFullYear(), 0, 1);
                            this.endDate = new Date();
                            this.dateRangeDraft = [
                                this.startDate.setHours(
                                    this.created_time.split(":")[0],
                                    this.created_time.split(":")[1]
                                ),
                                this.endDate,
                            ];
                        },
                    },
                ],
                selectDate: "",
                sentCallReportList: [],
                draftCallReportList: [],
                ajaxCallinprogress: true,
                searchKey: "",
                skip_temp:0,
                temp_total:0,
                total: 0,
                draft_total: 0,
                sent_total: 0,
                skip: 0,
                limit: 10,
                start: 0,
                end: 0,
                count: 0,
                showIllustrator: false,
                report_dropdown: [],
                selectDraftSend:  {
                    status: "sent",
                    name: "Completed",
                },
                filter: false,
                call_report_category_options: [],
                reportListLoading:false,
                call_report_category_selected: [],
                author_name_options: [],
                company_name_options: [],
                author_names_selected: [],
                customer_options: [],
                customers_selected: [],
                branch_options: [],
                title_name_options: [],
                branches_selected: [],
                department_options: [],
                departments_selected: [],
                company_names_selected: [],
                meeting_type_selected: [],
                title_name_selected: [],
                location_selected: [],
                receiver_type_selected:'',
                receiver_name_selected:[],
                dateRange: [],
                filtersLength: 0,
                filterCallReport: false,
                draftSelect: [],
                //columnConifg: [],
                //columnConfigDynamic: [],
                countries: [],
                isLoading: {
                    title: false,
                    customer: false,
                    author: false,
                    receiver:false,
                    recevier_type:false
                },
                branch_skip_count: 0,
                is_department_loading: false,
                department_skip_count: 0,
                showfilterData: {
                    author_name: [],
                    branch: [],
                    call_report_category: [],
                    created_date: null,
                    customer: [],
                    location: [],
                    department: [],
                    meeting_type: [],
                    title_name: [],
                    receiver_type:[],
                    receiver_name:[]
                },
                is_true: false,
                tab_show:[],
                receiver_name_options:[],
                receiver_type_selected:'',
                receiver_loading:false,
                receiver_type_options:["Contact","Customer","Lead"],
                receiver_scrollable:false,
                receiver_name_count:0,
                temp_receiver:'',
                lead_visible:false,
                receiver_visible:false,
                showCallReport: false,
                send_options:['Send to All','Restrict Manually'],
                showManualModal:false,
                view_permission_data:'',
                data_id:'',
                data_length:'',
                vendor_search_key: ''
            };
        },
        components: {
            HalfCircleSpinner,
            //ColumnConfig,
            DeleteCallReports,
            ManualSendModal
        },
        mixins: [callreport,convert, customer, leads,user_permission,contacts],
        methods: {
            uncheckSelected(){
                this.draftSelect = [];
                this.$forceUpdate();
            },
            //custom label added to show company name and lead nam ein dropdown
            /**@params = full_name, @params = company_name */
            customLabel ({ full_name, company_name }) {
                return `${full_name} – ${company_name}`
            },
            limitAuthor(count) {
                return `+ ${count} more`
            },
            //hide the permission modal
            hideSendModal(){
                this.showManualModal = false
            },
            //show the manual send modal
            /**@params = id, @params = company_name */
            showsendList(id){
                this.showManualModal = true;
                setTimeout(() => {
                    this.$modal.show('manualSendModal')
                }, 500);
                this.data_id = id
            },
            //checking the selected type of receiver
            /**@params = value, @params = company_name */
            typeSelected(value){
                if(value == 'Contact'){
                    this.receiver_name_selected = []
                    this.searchContactName()
                } else if(value == 'Lead'){
                    this.receiver_name_selected = []
                    this.searchLeadName()
                } else if(value == 'Vendor'){
                    this.receiver_name_selected = []
                    this.searchVendorName()
                } else {
                    this.receiver_name_selected = []
                    this.searchCustomer()
                }
            },
            //Api call to search the customer
            /**@params = value*/
            async searchCustomer(value){
                this.receiver_loading = true
                this.receiver_name_options = [];
                /**@params = search_key,@params = status,@params =skip,@params =limit, @params =sort_key, @params =sort_value, @params =receiver_type */
                let response = await this.getCustomerList({
                    search_key: value || '',
                    status: this.status,
                    skip: 0,
                    limit: 10,
                    sort_key: "customer_name",
                    sort_value: 1,
                    receiver_type:'Customer'
                })
                let customer_name_opt = response.response
                customer_name_opt.forEach(el => {
                    if(el.hasOwnProperty('customer_name')){
                        el['full_name'] = el.customer_name
                    }
                    this.receiver_name_options.push(el);

                });
                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.receiver_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });

                // this.receiver_name_options = this.receiver_name_options.map(x => {return x.customer_name})
                this.receiver_name_count = response.response.length;
                this.receiver_loading = false
                this.receiver_scrollable = false
            },
            //Api call to search the customer debouncer method
            /**@params = value*/
            async searchCustomerByKeyDebouncer(value){
                this.receiver_loading = true
                this.receiver_name_options = [];
                /**@params = search_key,@params = status,@params =skip,@params =limit, @params =sort_key, @params =sort_value, @params =receiver_type */
                let response = await this.getCustomerList({
                    search_key: value || '',
                    status: this.status,
                    skip: 0,
                    limit: 10,
                    sort_key: "customer_name",
                    sort_value: 1,
                    receiver_type:'Customer'
                })
                let customer_name_opt = response.response
                customer_name_opt.forEach(el => {
                    if(el.hasOwnProperty('customer_name')){
                        el['full_name'] = el.customer_name
                    }
                    this.receiver_name_options.push(el);

                });
                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.receiver_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });

                // this.receiver_name_options = this.receiver_name_options.map(x => {return x.customer_name})
                this.receiver_name_count = response.response.length;
                this.receiver_loading = false
                this.receiver_scrollable = false
            },
            //Api call to lazy loading of the  customer
            /**@params = reached*/
            async reachedEndOfCustomers(reached){
                this.receiver_visible = reached
                if (reached) {
                    if (this.receiver_scrollable == false) {
                        this.receiver_loading = true
                        /**@params = search_key,@params = status,@params =skip,@params =limit, @params =sort_key, @params =sort_value, @params =receiver_type */
                        let response = await this.getCustomerList({
                            status: this.status,
                            skip: this.receiver_name_count,
                            limit: 10,
                            search_key: "",
                            sort_key: "customer_name",
                            sort_value: 1,
                            receiver_type:'Customer'
                        })

                        this.temp_receiver = response.response.length;
                        if (response.skip == this.receiver_name_count) {
                            if (this.temp_receiver > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    if(el.hasOwnProperty('customer_name')){
                                        el['full_name'] = el.customer_name
                                    }
                                    this.receiver_name_options.push(el);
                                });
                                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.receiver_name_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });

                                });
                                // this.receiver_name_options = this.receiver_name_options.map(x => {return x.customer_name})
                                this.receiver_name_count += response.response.length;
                                //this.receiver_loading = false
                            } else {
                                this.receiver_scrollable = true
                                //this.receiver_loading = false
                            }
                        }
                        this.receiver_loading = false
                    }
                }
            },
            //Api call to search contact by name
            /**@params = value*/
            async searchContactNameByKeyDebouncer(value){
                this.receiver_loading = true
                /**@params = search_key,@params = status,@params =skip,@params =limit, @params =sort_key, @params =sort_value, @params =receiver_type */
                let params = {
                    search_key: value || '',
                    sort_key: "full_name",
                    sort_value: 1,
                    limit: this.limit,
                    skip : this.skip,
                    status: 'active',
                    receiver_type:'Contact'
                }
                let response = await this.getBusinessConatactList(params)
                this.receiver_name_options = response.response
                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.receiver_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.receiver_name_count = this.receiver_name_options.length
                this.receiver_loading  = false
                this.receiver_scrollable = false
            },
            //Api call to lazy loading of the  contact
            /**@params = value*/
            async searchContactName(value){
                this.receiver_loading = true
                /**@params = search_key,@params = status,@params =skip,@params =limit, @params =sort_key, @params =sort_value, @params =receiver_type */
                let params = {
                    search_key: value || '',
                    sort_key: "full_name",
                    sort_value: 1,
                    limit: this.limit,
                    skip : this.skip,
                    status: 'active',
                    receiver_type:'Contact'
                }
                let response = await this.getBusinessConatactList(params)
                this.receiver_name_options = response.response
                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.receiver_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.receiver_name_count = this.receiver_name_options.length
                this.receiver_loading  = false
                this.receiver_scrollable = false
            },
            //Api call to lazy loading of the  contact name
            /**@params = reached*/
            async reachedEndOfContactName(reached){
                this.contact_visible = reached
                if (reached) {
                    if (this.receiver_scrollable == false) {
                        this.receiver_loading = true
                        /**@params = search_key,@params = status,@params =skip,@params =limit, @params =sort_key, @params =sort_value, @params =receiver_type */
                        let response = await this.getBusinessConatactList({
                            skip: this.receiver_name_count,
                            limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                            search_key: "",
                            sort_key: "full_name",
                            sort_value: 1,
                            status: this.status,
                            receiver_type:'Contact'
                        })
                        this.temp_receiver = response.response.length;
                        if (response.skip == this.receiver_name_count) {
                            if (this.temp_receiver > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.receiver_name_options.push(el);
                                });
                                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.receiver_name_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.receiver_name_count += response.response.length;
                                this.receiver_loading = false
                            } else {
                                this.receiver_scrollable = true
                                this.receiver_loading = false
                            }
                        }
                        this.receiver_loading = false
                    }
                }
            },
            limitContactName(count){
                return `+ ${count} more`
            },
            //remove contact name
            /**@params = option*/
            removeContactName(option){
                this.temp_contact_name.forEach((el,index)=>{
                    if(el._id == option._id){
                        this.temp_contact_name.splice(index,1)
                    }
                })
            },
            //Api call to search lead name
            /**@params = value*/
            async searchLeadName(value) {
                this.receiver_loading = true
                 /**@params = search_key, @params =sort_key, @params =sort_value, @params =receiver_type */
                let params = {
                    search_key: '',
                    sort_key: "full_name",
                    sort_value: 1,
                    receiver_type:'Lead'
                }
                let response = await this.getLeadList(params)
                this.receiver_name_options = response.response
                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.receiver_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.receiver_name_count = this.receiver_name_options.length
                this.receiver_loading  = false
                this.receiver_scrollable = false
            },
            //Api call to search vendor name
            /**@params = value*/
            async searchVendorName(value) {
                this.receiver_loading = true
                 /**@params = search_key, @params =sort_key, @params =sort_value, @params =receiver_type */
                let params = {
                    searchdata: '',
                    filter_json: {},
                    skip: 0,
                    limit: 10,
                    sort_key: "company_name",
                    sort_value: 1
                }
                let response = await this.getVendorList(params)
                this.receiver_name_options = response.result
                this.receiver_name_options.forEach((el, el_index)=>{
                    if(el.hasOwnProperty('company_name')){
                        el['full_name'] = el.company_name
                        el['id'] = el._id
                    }
                })
                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.receiver_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.receiver_name_count = this.receiver_name_options.length
                this.receiver_loading  = false
                this.receiver_scrollable = false
            },
            async searchVendorListDebouncer(search_key) {
                this.receiver_loading = true
                 /**@params = search_key, @params =sort_key, @params =sort_value, @params =receiver_type */
                this.vendor_search_key = search_key || ''
                let params = {
                    searchdata: this.vendor_search_key,
                    filter_json: {},
                    skip: 0,
                    limit: 10,
                    sort_key: "company_name",
                    sort_value: 1
                }
                let response = await this.getVendorList(params)
                this.receiver_name_options = response.result
                this.receiver_name_options.forEach((el, el_index)=>{
                    if(el.hasOwnProperty('company_name')){
                        el['full_name'] = el.company_name
                        el['id'] = el._id
                    }
                })
                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.receiver_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.receiver_name_count = 0
                this.receiver_loading  = false
                this.receiver_scrollable = false
            },
            //Api call to lazy loading of the  Vendor
            /**@params = reached*/
            async reachedEndOfVendors(reached){
                this.receiver_visible = reached
                if (reached) {
                    if (this.receiver_scrollable == false) {
                        this.receiver_loading = true
                        /**@params = search_key,@params = status,@params =skip,@params =limit, @params =sort_key, @params =sort_value, @params =receiver_type */
                        let response = await this.getVendorList({
                            searchdata: this.vendor_search_key,
                            filter_json: {},
                            skip: this.receiver_name_count,
                            limit: 10,
                            sort_key: "company_name",
                            sort_value: 1
                        })

                        this.temp_receiver = response.result.length;
                        if (response.skip == this.receiver_name_count) {
                            if (this.temp_receiver > 0) {
                                let tempFiles = response.result;
                                tempFiles.forEach(el => {
                                    if(el.hasOwnProperty('company_name')){
                                        el['full_name'] = el.company_name
                                        el['id'] = el._id
                                    }
                                    this.receiver_name_options.push(el);
                                });
                                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.receiver_name_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });

                                });
                                // this.receiver_name_options = this.receiver_name_options.map(x => {return x.customer_name})
                                this.receiver_name_count += response.result.length;
                                //this.receiver_loading = false
                            } else {
                                this.receiver_scrollable = true
                                //this.receiver_loading = false
                            }
                        }
                        this.receiver_loading = false
                    }
                }
            },
            //Api call to search lead name debouncer
            /**@params = value*/
            async searchLeadNameByKeyDebouncer(value) {
                this.receiver_loading = true
                 /**@params = search_key, @params =sort_key, @params =sort_value, @params =receiver_type */
                let params = {
                    search_key: value || '',
                    sort_key: "full_name",
                    sort_value: 1,
                    receiver_type:'Lead'
                }
                let response = await this.getLeadList(params)
                this.receiver_name_options = response.response
                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.receiver_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.receiver_name_count = this.receiver_name_options.length
                this.receiver_loading  = false
                this.receiver_scrollable = false
            },
            //Api call to lazy loading of the  lead name
            /**@params = reached*/
            async reachedEndOfLeadName(reached) {
                this.lead_visible = reached
                if (reached) {
                    if (this.receiver_scrollable == false) {
                        this.receiver_loading = true
                        /**@params = search_key,@params = status,@params =skip,@params =limit, @params =sort_key, @params =sort_value, @params =receiver_type */
                        let response = await this.getLeadList({
                            skip: this.receiver_name_count,
                            limit: 10,
                            search_key: "",
                            sort_key: "full_name",
                            sort_value: 1,
                            receiver_type:'Lead'
                        })
                        this.temp_receiver = response.response.length;
                        if (response.skip == this.receiver_name_count) {
                            if (this.temp_receiver > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.receiver_name_options.push(el);
                                });
                                this.receiver_name_options = this.receiver_name_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.receiver_name_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.receiver_name_count += response.response.length;
                                this.receiver_loading = false
                            } else {
                                this.receiver_scrollable = true
                                this.receiver_loading = false
                            }
                        }
                        this.receiver_loading = false
                    }
                }
            },
            limitLeadName(count){
                return `+ ${count} more`
            },
            //remove lead name
            /**@params = option */
            removeLeadName(option){
                this.temp_receiver.forEach((el,index)=>{
                    if(el._id == option._id){
                        this.temp_receiver.splice(index,1)
                    }
                })
            },
            //convert the date format
            /**@params = str */
            convertViewCall(str) {
                var date = str.slice(0,11).split("/"),
                mnth = date[1],
                day = date[0],
                year = date[2];
                var newDate = [mnth,day,year].join("/");
                return newDate
            },
            //remove the created date
            removeCreatedDate(){
                this.dateRange = []
                this.update()
            },
            //Api call of sub module permission
            async submodulePermission(){
                // /**@params = id,@params = module_name */
                // let params = {
                //     id: 'sub_module',
                //     module_name : 'tools'
                // }
                // let response = await this.permittedModules(params)
                // this.tab_show = response.response
                let completedData = this.userPermissions.call_reports.permitted_actions.view
                let draftData = this.userPermissions.draft_call_reports.permitted_actions.view
                //checking the draft and completed data and calling the list api of the call reports
                if(draftData && completedData) {
                    this.report_dropdown.push({status: 'draft', name: 'Draft'});
                    this.report_dropdown.push({status: 'sent', name: 'Completed'});
                    this.selectDraftSend = {
                        status: "sent",
                        name: "Completed",
                    };
                    this.$forceUpdate();
                    this.getCallReportList("init");
                }
                else if(draftData) {
                    this.report_dropdown.push({status: 'draft', name: 'Draft'});
                    this.selectDraftSend = {
                        status: "draft",
                        name: "Draft",
                    };
                    this.$forceUpdate();
                    this.getDraftCallReportList("init");
                }
                else if(completedData ) {
                    this.report_dropdown.push({status: 'sent', name: 'Completed'});
                    this.selectDraftSend = {
                        status: "sent",
                        name: "Completed",
                    };
                    this.$forceUpdate();
                    this.getCallReportList("init");
                }
            },
            //show the dropdown data
            showData() {
                let completedData = this.userPermissions.call_reports.permitted_actions.view
                if(completedData ) {
                    this.report_dropdown.push({status: 'sent', name: 'Completed'});
                    this.report_dropdown = this.report_dropdown.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.report_dropdown.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                }
            },
            //show/hide the filter modal
            showFilter() {
                this.filter = true;
            },
            //get the completed call report list
            /**@params = data */
            getCompletedCallReports(data) {
                if(data.target.value) {
                    this.sentCallReportList = [];
                    this.getCallReportList('init');
                }
            },
             //get the drafted call report list
            /**@params = data */
            getDraftCallReports(data) {
                if(data.target.value) {
                    this.draftCallReportList = [];
                    this.getDraftCallReportList('init');
                }
            },
            //Pagination
            previousPageSent() {
                this.temp_total = 0
                this.skip_temp = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.getCallReportList("init");
            },
            nextPageSent() {
                this.skip_temp = this.skip + this.limit > this.sent_total ? this.sent_total : this.skip + this.limit;
                if (this.skip_temp >= this.sent_total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.getCallReportList("init");
            },
            previousPageDraft() {
                this.temp_total = 0
                this.skip_temp = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.getDraftCallReportList();
            },
            nextPageDraft() {
                this.skip_temp = this.skip + this.limit > this.draft_total ? this.draft_total : this.skip + this.limit;
                if (this.skip_temp >= this.draft_total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.getDraftCallReportList();
            },
            //remove the selected data from dropdown
            /**@params = option, @params = type */
            removeData(option,type){
                this.draftSelect = [];
                this.filterCallReport = true;
                if(type == 'author_name'){
                    this.author_names_selected.forEach((el,index)=>{
                        if(el.id == option.id){
                            this.author_names_selected.splice(index,1)
                        }
                    })
                } else if(type == 'receiver'){
                    this.receiver_name_selected.forEach((el,index)=>{
                        if(el == option){
                            this.receiver_name_selected.splice(index,1)
                        }
                    })
                } else if(type == 'call_report_category'){
                    this.call_report_category_selected.forEach((el,index)=>{
                        if(el == option){
                            this.call_report_category_selected.splice(index,1)
                        }
                    })
                    this.showfilterData.call_report_category = []
                } else if(type == 'location'){
                    this.location_selected.forEach((el,index)=>{
                        if(el == option){
                            this.location_selected.splice(index,1)
                        }
                    })
                    this.showfilterData.location = []
                } else if(type == 'meeting_type'){
                    this.meeting_type_selected.forEach((el,index)=>{
                        if(el == option){
                            this.meeting_type_selected.splice(index,1)
                        }
                    })
                    this.showfilterData.meeting_type = []
                } else if(type == 'title_name'){
                    this.title_name_selected.forEach((el,index)=>{
                        if(el == option){
                            this.title_name_selected.splice(index,1)
                        }
                    })
                } else if(type == 'receiver_type'){
                    this.receiver_type_selected = ''
                    this.showfilterData.receiver_type_selected = []
                    if(this.receiver_name_selected.length > 0){
                        this.receiver_name=[],
                        this.receiver_name_selected=[]
                    }
                }
            },
            //remove author name
            /**@params = option */
            removeAuthor(option){
               // this.filterCallReport = true;
                this.author_names_selected.forEach((el,index)=>{
                    if(el.id == option.id){
                        this.author_names_selected.splice(index,1)
                    }
                })
                //this.showfilterData.author_name = []
            },
            //remove company name
            /**@params = option */
            removeCompName(option) {

               // this.filterCallReport = true;
                this.company_names_selected.forEach((el,index)=>{
                    if(el == option){
                        this.company_names_selected.splice(index,1)
                    }
                })
            },
            //remove receiver name
            /**@params = option */
            removeReceiverName(option) {
                //this.filterCallReport = true;
                this.receiver_name_selected.forEach((el,index)=>{
                    if(el == option){
                        this.receiver_name_selected.splice(index,1)
                    }
                })
            },
            //remove receiver type
            /**@params = option */
            // removeReceiverType(option) {
            //     //this.filterCallReport = true;
            //     this.receiver_type_selected = ''
            //     this.showfilterData.receiver_type_selected = []
            //     if(this.receiver_name_selected.length > 0){
            //         this.receiver_name=[],
            //         this.receiver_name_selected=[]
            //     }
            // },
            //remove call report type
            /**@params = option */
            removeCallReportType(option) {
               // this.filterCallReport = true;
                this.call_report_category_selected.forEach((el,index)=>{
                    if(el == option){
                        this.call_report_category_selected.splice(index,1)
                    }
                })
                this.showfilterData.call_report_category = []
            },
            //remove meeting type
            /**@params = option */
            removeMeetingType(option) {
               // this.filterCallReport = true;
                this.meeting_type_selected.forEach((el,index)=>{
                    if(el == option){
                        this.meeting_type_selected.splice(index,1)
                    }
                })
                this.showfilterData.meeting_type = []
            },
            //remove customer company name
            /**@params = option */
            removeCustomerCompanyName(option) {
                //this.filterCallReport = true;
                this.customers_selected.forEach((el,index)=>{
                    if(el == option){
                        this.customers_selected.splice(index,1)
                    }
                })
                //this.showfilterData.customer = []
            },
            //remove title name
            /**@params = option */
            removeTitleName(option) {
                //this.filterCallReport = true;
                this.title_name_selected.forEach((el,index)=>{
                    if(el == option){
                        this.title_name_selected.splice(index,1)
                    }
                })
            },
            //remove location
            /**@params = option */
            removeLocation(option) {
                //this.filterCallReport = true;
                this.location_selected.forEach((el,index)=>{
                    if(el == option){
                        this.location_selected.splice(index,1)
                    }
                })
                this.showfilterData.location = []
            },
            //calling the column config
            columnCallReportList() {
                this.getCallReportList('init');
                this.getDraftCallReportList();
            },
            //show the selected company name
            /**@params = comp */
            companyNameSelected(comp) {
                if (comp != '') {
                    this.comp_id = this.loggedInUser.company_id;
                    this.disable_branch_depart = true;
                } else {
                    this.comp_id = '';
                    this.disable_branch_depart = false;
                }
                this.update()
            },
            //using momnet js for date
            moment(date) {
                return moment(date);
            },
            //reset the date range for completed call reports
            resetSend() {
                this.dateRangeSent = [];
                this.getCallReportList();
            },
            //reset the date range for draft call reports
            resetDraftcalender() {
                this.dateRangeDraft = [];
                this.getDraftCallReportList();
            },
            //select all data of completed call report
            selectAll(event) {
                if(event.target.checked === true){
                    this.draftCallReportList.forEach((draft_cr, index) => {
                        if(this.draftCallReportList[index].checked == false){
                            this.draftCallReportList[index].checked = true;
                            this.draftSelect.push(draft_cr._id)
                        }
                    })
                } else {
                    this.draftCallReportList.forEach((el_draft_cr, index) => {
                        this.draftCallReportList[index].checked = false;
                    })
                    this.draftCallReportList.forEach((el_draft_cr, el_draft_cr_index) => {
                        this.draftSelect.forEach((selected_draft_cr, selected_draft_cr_index) => {
                            if(el_draft_cr._id == selected_draft_cr){
                                this.draftSelect.splice(selected_draft_cr_index, 1)
                            }
                        })
                    })
                }
            },
            //select all data of draft call report
            /**@params = _id */
            draftSelected(event, draft, index) {
                if(event.target.checked){
                    this.draftSelect.push(draft._id)
                } else {
                    this.draftSelect.forEach((selected_draft_cr, selected_draft_cr_index) => {
                        if(selected_draft_cr === draft._id){
                            this.draftSelect.splice(selected_draft_cr_index, 1)
                        }
                    })
                }
                if(this.draftCallReportList.every(x => x.checked == true)){
                    this.select_all_draft = true;
                } else {
                    this.select_all_draft = false;
                }
            },
            //reset the sent data for completed call reports
            resetSent() {
                let startDate = new Date();
                startDate.setHours(
                    this.created_time.split(":")[0],
                    this.created_time.split(":")[1]
                );
                let endDate = new Date();
                this.dateRange = [startDate, endDate];
                this.selectDraftSend = {
                    status: "sent",
                    name: "Completed",
                };
                this.onDateChangeSent();
                this.convertUTC = false;
            },
            //loading the list view on change of the completed call report date
            onDateChangeSent() {
                this.getCallReportList("init");
            },
            //reset the draft date
            resetDraft() {
                let startDate = new Date();
                startDate.setHours(
                    this.created_time.split(":")[0],
                    this.created_time.split(":")[1]
                );
                let endDate = new Date();
                this.dateRangeDraft = [startDate, endDate];
                this.selectDraftSend = {
                    status: "draft",
                    name: "Draft",
                };
                this.onDateChangeDraft();
                this.convertUTC = false;
            },
            //loading the list view on change of the drafted call report date
            onDateChangeDraft() {
                this.getDraftCallReportList("init");
            },
            //change the status fo the call report
            /**@params = selected_options */
            changedCallReportStatus(selectedOption) {
                //receive the value selected (return an array if is multiple)
                if (selectedOption.status == "sent") {
                    this.selectDraftSend = {
                        status: 'sent',
                        name: 'Completed'
                    }
                    this.$forceUpdate();
                    this.closeFilters()
                    this.resetFilters();
                } else if (selectedOption.status == "draft") {
                    this.selectDraftSend = {
                        status: 'draft',
                        name: 'Draft'
                    }
                    this.$forceUpdate();
                    this.closeFilters()
                    this.resetFilters();
                }
                // this.update();
            },
            //create a call report
            /**@params = category */
            createCallReport(category) {
                this.$store.commit("setCallReportCategory", category);
                this.$router.push("/callreport");
            },
            //view the completed call report
            /**@params = callReport_id */
            viewSendCallReport(callReport_id) {
                if(this.userPermissions.call_reports.permitted_actions.view || this.userPermissions.draft_call_reports.permitted_actions.view){
                    this.$router.push("/viewcallreport/" + callReport_id);
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                }
            },
            //edit the drafted call report
            /**@params = draftcallReport_id */
            editDraftCallReport(draftcallReport_id) {
                if(this.userPermissions.draft_call_reports.permitted_actions.edit){
                    this.$router.push("/editcallreport/" + draftcallReport_id);
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                }
            },
            //APi call to get column config data
            // async getColumnConfig() {
            //     let res = await this.$http.get("/user_column_config/");
            //     if (res.data.status_id == 1) {
            //         this.columnConifg = res.data.response.call_report;
            //         this.columnConfigDynamic = [...new Set(this.columnConifg.map(x => x.value))];
            //     }
            // },
            //APi call to get the completed call report list
            /**@params = param */
            async getCallReportList(param) {
                try {
                    this.ajaxCallinprogress = true;
                    //this.getColumnConfig();
                    if (param == "prev") this.count--;
                    else if (param == "next") this.count++;
                    else if (param == "init") {
                        this.count = 0;
                    } else if (param == "searchKey") {
                        this.count = 0;
                    }
                    this.sentCallReportList = [];
                    let params = {
                        search_key: this.searchKey,
                        limit: this.limit == "" || this.limit == 0 || this.limit < 0 ? 1 : this.limit,
                        skip: this.skip,
                        filter_json: {},
                    };
                    if (this.call_report_category_selected.length) {
                        Object.assign(params.filter_json, {
                            call_report_category: this.call_report_category_selected,
                        });
                    }
                    if (this.receiver_type_selected.length) {
                        Object.assign(params.filter_json, {
                            receiver_type: this.receiver_type_selected,
                        });
                    }
                    if (this.receiver_name_selected.length) {
                        let receiver_names = [];
                        this.receiver_name_selected.forEach(x => {
                            receiver_names.push(x.id);
                        });
                        Object.assign(params.filter_json, {
                            receiver_name: receiver_names,

                        });
                    }
                    if (this.customers_selected.length) {
                        let customers = [];
                        this.customers_selected.forEach(x => {
                            customers.push(x.customer_name);
                        });
                        Object.assign(params.filter_json, {
                            customer: customers,
                        });
                    }
                    if (this.customers_selected.length) {
                        let companies = [];
                        this.customers_selected.forEach(x => {
                            companies.push(x.customer_name);
                        });
                        if (params.hasOwnProperty("customer")) {
                            companies.forEach(x => {
                                params.customer.push(x);
                            });
                        } else {
                            Object.assign(params.filter_json, {
                                customer: companies,
                            });
                        }
                    }
                    if (this.author_names_selected.length) {
                        // Object.assign(params.filter_json, {
                        //     author_name: this.author_names_selected,
                        // });
                        params.filter_json["author_name"] = JSON.parse(JSON.stringify(this.author_names_selected))
                        params.filter_json.author_name.forEach((x, index) => {
                            params.filter_json.author_name[index] = x.full_name? x.full_name :x;
                        });
                    }
                    if (this.dateRange.length) {
                        Object.assign(params.filter_json, {
                            created_date: {
                                start_date: ("0" + new Date(this.dateRange[0]).getDate()).slice(-2) + "/" + (
                                        "0" + (new Date(this.dateRange[0]).getMonth() + 1)).slice(-2) + "/" +
                                    new Date(this.dateRange[0]).getFullYear(),
                                end_date: ("0" + new Date(this.dateRange[1]).getDate()).slice(-2) + "/" + ("0" +
                                        (new Date(this.dateRange[1]).getMonth() + 1)).slice(-2) + "/" +
                                    new Date(this.dateRange[1]).getFullYear(),
                            },
                        });
                    }
                    if (this.meeting_type_selected.length) {
                        Object.assign(params.filter_json, {
                            meeting_type: this.meeting_type_selected,
                        });
                    }
                    if (this.title_name_selected.length) {
                        Object.assign(params.filter_json, {
                            title_name: this.title_name_selected,
                        });
                    }
                    if (this.location_selected.length) {
                        Object.assign(params.filter_json, {
                            location: this.location_selected,
                        });
                    }
                    //including the filter data of completed call report
                    this.showfilterData = {
                        author_name: JSON.parse(JSON.stringify(this.author_names_selected)),
                        call_report_category: this.call_report_category_selected,
                        receiver_type: this.receiver_type_selected,
                        receiver_name :this.receiver_name_selected,
                        created_date: this.dateRange.length ? Object.assign(params.filter_json, {
                            created_date: {
                                start_date: ("0" + new Date(this.dateRange[0]).getDate()).slice(-2) + "/" + (
                                        "0" + (new Date(this.dateRange[0]).getMonth() + 1)).slice(-2) + "/" +
                                    new Date(this.dateRange[0]).getFullYear(),
                                end_date: ("0" + new Date(this.dateRange[1]).getDate()).slice(-2) + "/" + ("0" +
                                        (new Date(this.dateRange[1]).getMonth() + 1)).slice(-2) + "/" +
                                    new Date(this.dateRange[1]).getFullYear(),
                            },
                        }):null,
                        location: this.location_selected,
                        // department: this.departments_selected,
                        meeting_type: this.meeting_type_selected,
                        title_name: this.title_name_selected
                    }
                    //Api call of the completed call report and passing all the data  as params
                    let res = await this.getCallReportsList(params);
                   // this.ajaxCallinprogress = true
                    this.sentCallReportList = res.response;
                    this.sentCallReportList.forEach((x, index) => {
                        let company_name = x.receiver_details.company_name
                        if(typeof(x.receiver_details.company_name) == 'object'){
                            if(x.receiver_details.company_name.length == 0){
                                company_name = "-"
                            } else {
                                company_name = x.receiver_details.company_name
                            }
                        } else {
                            company_name = x.receiver_details.company_name
                        }
                        let data = x.receiver_details.name
                        let status = x.receiver_details.status
                        // this.sentCallReportList.push({
                            // _id = x._id;
                            // receiver_company_count = x.receiver_company_count;
                            // receiver_count = x.receiver_count;
                            // edit_permission = x.edit_permission;
                            x.call_report_number = {
                                value: x.call_report_number || "-",
                                order: 1,
                            };
                            x.receiver_details = {
                                value: data || "-" ,
                                order: 2,
                            };
                            x.receiver_type ={
                                value: x.receiver_type || "-" ,
                                order: 3,
                            };
                            x.call_report_type = {
                                value: x.call_report_type || "-",
                                order: 4,
                            }
                            x.status = {
                                value: status || "-",
                                order: 5,
                            };
                            x.title_name = {
                                value: x.title || "-",
                                order: 6,
                            };
                            x.timestamp = {
                                value: x.timestamp || "-",
                                order: 7,
                            };
                            x.author ={
                                value: x.author_name || "-",
                                order: 8,
                            };
                            x.receiver_company_details = {
                                value: company_name || "-" ,
                                order: 9,
                            };
                        // });
                        // if (this.columnConfigDynamic.includes("Start Date")) {
                        //     Object.assign(this.sentCallReportList[index], {
                        //         start_date: {
                        //             value: x.meeting_time_from || "-",
                        //             order: this.columnConfigDynamic.indexOf("Start Date") + 1,
                        //         }
                        //     });
                        // }
                    });
                    //this.total = res.data.total;
                    this.sent_total = res.total
                    this.$forceUpdate();
                    this.start = this.count * this.limit + 1;
                    this.end = this.count * this.limit + this.limit < this.sent_total ? this.count * this.limit + this.limit : this.sent_total;

                    // this.showCallReport = true;
                    // if (
                    //     this.sentCallReportList.length == 0 &&
                    //     !this.ajaxCallinprogress &&
                    //     !this.searchKey
                    // ) {
                    //     this.showCallReport = true;
                    // } else {
                    //     this.showCallReport = false;
                    // }
                    this.ajaxCallinprogress = false;
                    this.filterCallReport = false;
                }
                catch(err){
                    this.ajaxCallinprogress = false;
                    this.filterCallReport = false;
                }

            },
            //APi call to get the draft call report list
            /**@params = param */
            async getDraftCallReportList(param) {
                //this.total = 0;
                this.ajaxCallinprogress = true;
                //this.getColumnConfig();
                if (param == "prev") this.count--;
                else if (param == "next") this.count++;
                else if (param == "init") {
                    this.count = 0;
                } else if (param == "searchKey") {
                    this.count = 0;
                }
                this.draftCallReportList = [];
                this.filtersLength = 0;
                let params = {
                    search_key: this.searchKey,
                    limit: this.limit == "" || this.limit == 0 || this.limit < 0 ? 1 : this.limit,
                    skip: this.skip,
                    filter_json: {},
                };
                if (this.call_report_category_selected.length) {
                    Object.assign(params.filter_json, {
                        call_report_category: this.call_report_category_selected,
                    });
                }
                if (this.receiver_type_selected.length) {
                    Object.assign(params.filter_json, {
                        receiver_type: this.receiver_type_selected,
                    });
                }
                if(this.receiver_name_selected.length){
                    let receiver_names = [];
                    this.receiver_name_selected.forEach(x => {
                        receiver_names.push(x.id);
                    });
                    Object.assign(params.filter_json, {
                        receiver_name: receiver_names,
                    });
                }
                if (this.customers_selected.length) {
                    let customers = [];
                    this.customers_selected.forEach(x => {
                        customers.push(x.customer_name);
                    });
                    Object.assign(params.filter_json, {
                        customer: customers,
                    });
                }
                if (this.author_names_selected.length) {
                    Object.assign(params.filter_json, {
                        author_name: this.author_names_selected,
                    });
                    params.filter_json.author_name.forEach((x, index) => {
                        params.filter_json.author_name[index] = x.full_name? x.full_name :x;
                    });
                }
                if (this.dateRange.length) {
                    Object.assign(params.filter_json, {
                        created_date: {
                            start_date: ("0" + new Date(this.dateRange[0]).getDate()).slice(-2) + "/" + (
                                    "0" + (new Date(this.dateRange[0]).getMonth() + 1)).slice(-2) + "/" +
                                new Date(this.dateRange[0]).getFullYear(),
                            end_date: ("0" + new Date(this.dateRange[1]).getDate()).slice(-2) + "/" + ("0" +
                                    (new Date(this.dateRange[1]).getMonth() + 1)).slice(-2) + "/" +
                                new Date(this.dateRange[1]).getFullYear(),
                        },
                    });
                }
                if (this.meeting_type_selected.length) {
                    Object.assign(params.filter_json, {
                        meeting_type: this.meeting_type_selected,
                    });
                }
                if (this.title_name_selected.length) {
                    Object.assign(params.filter_json, {
                        title_name: this.title_name_selected,
                    });
                }
                if (this.location_selected.length) {
                    Object.assign(params.filter_json, {
                        location: this.location_selected,
                    });
                }
                //including the filter data of drafted call report
                this.showfilterData = {
                    author_name: this.author_names_selected,
                    call_report_category: this.call_report_category_selected,
                    receiver_type: this.receiver_type_selected,
                    receiver_name :this.receiver_name_selected,
                    created_date: this.dateRange.length ? Object.assign(params.filter_json, {
                        created_date: {
                            start_date: ("0" + new Date(this.dateRange[0]).getDate()).slice(-2) + "/" + (
                                    "0" + (new Date(this.dateRange[0]).getMonth() + 1)).slice(-2) + "/" +
                                new Date(this.dateRange[0]).getFullYear(),
                            end_date: ("0" + new Date(this.dateRange[1]).getDate()).slice(-2) + "/" + ("0" +
                                    (new Date(this.dateRange[1]).getMonth() + 1)).slice(-2) + "/" +
                                new Date(this.dateRange[1]).getFullYear(),
                        },
                    }):null,
                    //customer: this.customers_selected,
                    location: this.location_selected,
                    // department: this.departments_selected,
                    meeting_type: this.meeting_type_selected,
                    title_name: this.title_name_selected
                }
                //Api call of the drafted call report and passing all the data  as params
                let res = await this.$http.post("/call_report/get_draft", params);
                if (res.data.status_id == 1 && this.searchKey == res.data.search_key) {
                    this.draftCallReportList = [];
                    res.data.response.forEach((x, index) => {
                        let company_name = x.receiver_details.company_name
                        if(typeof(x.receiver_details.company_name) == 'object'){
                            if(x.receiver_details.company_name.length == 0){
                                company_name = "-"
                            } else {
                                company_name = x.receiver_details.company_name
                            }
                        } else {
                            company_name = x.receiver_details.company_name
                        }
                        let data = x.receiver_details.name
                        let status = x.receiver_details.status
                        this.draftCallReportList.push({
                            _id: x._id,
                            receiver_company_count: x.receiver_company_count,
                            call_report_number: {
                                value: x.call_report_number || "-",
                                order: 1,
                            },

                            receiver_details: {
                                value: data || "-" ,
                                order: 2,
                            },
                            receiver_type:{
                                value: x.receiver_type || "-" ,
                                order: 3,
                            },
                            call_report_type: {
                                value: x.call_report_type || "-",
                                order: 4,
                            },
                            status: {
                                value: status ||  "-",
                                order: 5,
                            },
                            title_name: {
                                value: x.title || "-",
                                order: 6,
                            },
                            timestamp: {
                                value: x.timestamp || "-",
                                order: 7,
                            },
                            author: {
                                value: x.author_name || "-",
                                order: 8,
                            },
                            receiver_company_details: {
                                value: company_name || "-" ,
                                order: 9,
                            },
                        });
                    });
                    this.draft_total = res.data.total
                    //this.total = res.data.total;
                    this.draftCallReportList.forEach((per_cont, per_cont_index) => {
                        this.draftCallReportList[per_cont_index].checked = false;
                        if(this.draftSelect.length){
                            this.draftSelect.forEach((selected, selected_index) => {
                                if(selected === per_cont._id){
                                    this.draftCallReportList[per_cont_index].checked = true;
                                }
                            })
                        }
                    })
                    if(this.draftCallReportList.every(x => x.checked == true)){
                        this.select_all_draft = true;
                    } else {
                        this.select_all_draft = false;
                    }
                    this.start = this.count * this.limit + 1;
                    this.end = this.count * this.limit + this.limit < this.draft_total ? this.count * this.limit + this.limit : this.draft_total;
                    if (
                        this.draftCallReportList.length == 0 &&
                        !this.ajaxCallinprogress &&
                        !this.searchKey
                    ) {
                        this.showIllustrator = true;
                    } else {
                        this.showIllustrator = false;
                    }
                }
                this.ajaxCallinprogress = false;
                this.filterCallReport = false;
            },
            //delete the drafted data
            deleteDraft() {
                this.deleteDraftConfirm();
            },
            //copy the call report using id
            /**@params = id */
            copyCallReport(id) {
                localStorage.setItem("callreportid", id);
                this.$router.push("/copycallreport/"+id);
            },
            //Api call to confirm the delete draft
            async deleteDraftConfirm() {
                let res = await this.$http.post("/call_report/drafts/delete", {
                    id: this.draftSelect
                });
                if (res.data.status_id == 1) {
                    this.$swal({
                        text: "Call Report Deleted Successfully",
                        type: "success",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#005dae",
                    }).then(() => {
                        this.draftSelect = [];
                        this.getDraftCallReportList("init");
                    });
                }
            },
            //get the call report type
            getCallReportType() {
                this.reportListLoading = true;
                this.$http.get("/call_report/get_call_report_category").then(res => {
                    if (res.data.status_id == 1) {
                        res.data.response.value.forEach(x => {
                            this.call_report_category_options.push(x.name);
                        });
                    }
                    this.call_report_category_options = this.call_report_category_options.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.call_report_category_options.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                });
                this.reportListLoading = false;
            },
            //Fetching the Author data
            /**@params = key */
            async fetchAuthor(key) {
                this.isLoading.author = true;
                this.author_name_options = [];
                if (key) {
                    this.searchKey = key;
                }
                /**@params = search_key, @params = skip, @parmas = limit,@params = company_id, @parmas = sort_key,@parmas = sort_value  */
                let params = {
                    search_key: this.searchKey,
                    skip: 0,
                    limit: 10,
                    company_id: this.loggedInUser.company_id,
                    sort_key:'full_name',
                    sort_value:1
                }
                let res = await this.getAssigned(params)
                this.author_name_options = res.response;
                this.author_name_options = this.author_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.author_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.count = this.author_name_options.length;
                // this.isLoadingemployees = false;
                // this.author_name_options = this.author_name_options.concat(
                //     this.push_author_name_optionsInternal
                // );
                this.author_skip_count = res.response.length
                this.isLoading.author = false;
            },
            //lazy laoding of the  author details
            /**@params = reached */
            async getMoreAuthorDetails(reached) {
                if (reached) {
                    this.isLoading.author = true;
                    /**@params = search_key, @params = skip, @parmas = limit,@params = company_id, @parmas = sort_key,@parmas = sort_value  */
                    let params = {
                        skip: this.author_skip_count,
                        limit: 10,
                        search_key: this.searchKey,
                        company_id: this.loggedInUser.company_id,
                        sort_key:'full_name',
                        sort_value:1
                    }
                    let res = await this.getAssigned(params)
                    if (res.skip == this.author_skip_count) {
                        let tempFiles = res.response;
                        tempFiles.forEach(el => {
                            this.author_name_options.push(el);
                        });
                        this.author_name_options = this.author_name_options.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.author_name_options.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.author_skip_count += res.response.length;
                        this.isLoading.author = false;
                    }
                }
            },
            //search author details using debouncer
            /**@params = search_change */
            async SearchAuthorDetailsDobouncer(search_change){
                this.isLoading.author = true;
                /**@params = search_key, @params = skip, @parmas = limit,@params = company_id, @parmas = sort_key,@parmas = sort_value  */
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: search_change,
                    company_id: this.loggedInUser.company_id,
                    sort_key:'full_name',
                    sort_value:1
                }
                let res = await this.getAssigned(params)
                this.author_name_options = res.response;
                this.author_name_options = this.author_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.author_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.author_skip_count = this.author_name_options.length
                this.isLoading.author = false;
            },
            //fetch the customer details
            /**@params = key */
            async fetchCustomers(key) {

                this.isLoading.customer = true;
                this.customer_options = [];
                let searchKey = "";
                if (key) {
                    searchKey = key;
                }
                /**@params = search_key, @params = skip, @parmas = limit*/
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: searchKey,
                };
                let res = await this.getCustomerList(params);
                if (res.status_id == 1) {
                    this.customer_options = [];
                    res.response.forEach(x => {
                        this.customer_options.push(x);
                    });
                    this.isLoading.customer = false;
                }
            },
            //Apic all to fetch teh title name
            async fetchTitleName() {
                this.isLoading.title = true;
                this.title_name_options = [];
                /**@params = search_key, @params = skip, @parmas = limit*/
                let params = {
                    search_key: '',
                    skip: 0,
                    limit: 10,
                };
                let res = await this.$http.post("/call_report/get_title_names_dropdown", params);
                if (res.data.status_id == 1) {
                    this.title_name_options = res.data.response;
                    this.title_name_options = this.title_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.title_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                    this.isLoading.title = false;
                }
            },
            //Fetch title name for search
            /**@params = key */
            async fetchTitleNameDebouncer(key) {
                this.isLoading.title = true;
                this.title_name_options = [];
                // if (key) {
                //     searchKey = key;
                // }
                /**@params = search_key, @params = skip, @parmas = limit*/
                let params = {
                    search_key: key,
                    skip: 0,
                    limit: 10,
                };
                let res = await this.$http.post("/call_report/get_title_names_dropdown", params);
                if (res.data.status_id == 1) {
                    this.title_name_options = res.data.response;
                    this.title_name_options = this.title_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.title_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                    this.isLoading.title = false;
                }
            },
            //fetch the draft title name
            async fetchDraftTitleName() {
                this.isLoading.title = true;
                this.title_name_options = [];
                /**@params = search_key, @params = skip, @parmas = limit, @params = is_draft*/
                let params = {
                    search_key: '',
                    skip: 0,
                    limit: 10,
                    is_draft:true
                };
                let res = await this.$http.post("/call_report/get_title_names_dropdown", params);
                if (res.data.status_id == 1) {
                    this.title_name_options = res.data.response;
                    this.title_name_options = this.title_name_options.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.title_name_options.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.isLoading.title = false;
                }
            },
            //search the draft title name
            /**@params = key */
            async fetchDraftTitleNameDebouncer(key) {
                this.isLoading.title = true;
                this.title_name_options = [];
                /**@params = search_key, @params = skip, @parmas = limit, @params = is_draft*/
                let params = {
                    search_key: key,
                    skip: 0,
                    limit: 10,
                    is_draft:true
                };
                let res = await this.$http.post("/call_report/get_title_names_dropdown", params);
                if (res.data.status_id == 1) {
                    this.title_name_options = res.data.response;
                    this.title_name_options = this.title_name_options.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.title_name_options.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.isLoading.title = false;
                }
            },
            //reset all seelcted filters
            resetFilters() {
                this.draftSelect = [];
                this.dateRange = [];
                this.call_report_category_selected = [];
                this.author_names_selected = [];
                this.receiver_type_selected ="";
                this.meeting_type_selected = [];
                this.title_name_selected = [];
                this.location_selected = [];
                this.receiver_name_selected=[];
                this.showfilterData = {
                    author_name: [],
                    call_report_category: [],
                    created_date: null,
                    location: [],
                    meeting_type: [],
                    title_name: [],
                    receiver_type:'',
                    receiver_name:[],
                }
                this.update()
               // this.filter = false
            },
            //close filters modal
            closeFilters() {
                this.filter = false;
                this.dateRange = [];
                this.call_report_category_selected = [];
                this.author_names_selected = [];
                this.receiver_type_selected ="";
                this.meeting_type_selected = [];
                this.title_name_selected = [];
                this.location_selected = [];
                this.receiver_name_selected=[];
                this.showfilterData = {
                    author_name: [],
                    call_report_category: [],
                    created_date: null,
                    location: [],
                    meeting_type: [],
                    title_name: [],
                    receiver_type:'',
                    receiver_name:[],
                }
            },
            //update
            update(){
                this.skip = 0;
                this.limit = 10;
                if (this.selectDraftSend.status == "sent") {
                    this.selectDraftSend = {
                        status: 'sent',
                        name: 'Completed'
                    }
                    this.$forceUpdate();
                    this.getCallReportList("init");
                } else {
                    this.selectDraftSend = {
                        status: 'draft',
                        name: 'Draft'
                    }
                    this.$forceUpdate();
                    this.getDraftCallReportList("init");
                }
            }
        },
        watch: {
            filterCallReport: function (val) {
                if (val) {
                    if (this.selectDraftSend.status == "sent") {
                        this.selectDraftSend = {
                            status: 'sent',
                            name: 'Completed'
                        }
                        this.$forceUpdate();
                        this.getCallReportList("init");
                    } else {
                        this.selectDraftSend = {
                            status: 'draft',
                            name: 'Draft'
                        }
                        this.$forceUpdate();
                        this.getDraftCallReportList("init");
                    }
                }
            },
            // 'selectDraftSend.status': function (val) {
            //     if (val == 'sent') {
            //         this.selectDraftSend = {
            //             status: 'sent',
            //             name: 'Completed'
            //         }
            //         this.$forceUpdate();
            //         this.getCallReportList("init");
            //     } else {
            //         this.selectDraftSend = {
            //             status: 'draft',
            //             name: 'Draft'
            //         }
            //         this.$forceUpdate();
            //         this.getDraftCallReportList("init");
            //     }
            // },
            limit: function(){
                if(this.selectDraftSend.status == 'sent'){
                    this.getCallReportList()
                } else if(this.selectDraftSend.status == 'draft'){
                    this.getDraftCallReportList()
                }
            },
        },
        created() {
            this.SearchAuthorDetails = debounce(this.SearchAuthorDetailsDobouncer, 500)
            this.SearchTitleName = debounce(this.fetchTitleNameDebouncer, 500)
            this.SearchDraftTitleName = debounce(this.fetchDraftTitleNameDebouncer, 500)
            this.searchContactNameByKey = debounce(this.searchContactNameByKeyDebouncer, 500)
            this.searchCustomerByKey = debounce(this.searchCustomerByKeyDebouncer, 500)
            this.searchVendorList = debounce(this.searchVendorListDebouncer, 500)
            this.searchLeadNameByKey = debounce(this.searchLeadNameByKeyDebouncer, 500)
            if (localStorage.hasOwnProperty("backtodraft")) {
                this.selectDraftSend = {
                    status: "draft",
                    name: "Draft",
                };
                this.dateRange = [];
                this.report_dropdown.push({status: 'draft', name: 'Draft'});
                this.report_dropdown.push({status: 'sent', name: 'Completed'});
                this.$forceUpdate()
                this.getDraftCallReportList("init");
            } else {
                this.submodulePermission()
            }
            this.company_name_options.push(this.account.company_name);
            for (let i = 10; i <= 50; i+=10) {
                this.pageLimit.push(i);
            }
        },
        mounted() {
            // if (localStorage.hasOwnProperty("from_edit_draft")) {
            //     console.log("hi1")
            //     this.selectDraftSend = {
            //         name: "Draft",
            //         status: "draft"
            //     }
            //     console.log(this.selectDraftSend)
            // }
            this.countries = countries;
            //this.getCallReportType();
        },
        destroyed() {
            localStorage.clear();
        },
        computed: {
            //get the completed skip count
            getSkipCount(){
                let skip_count ;
                if(this.selectDraftSend.status === 'sent'){
                    if(this.sent_total == 0 ) {
                        return 0
                    } else {
                        skip_count = this.skip>this.sent_total?this.sent_total:this.skip+1;
                        return skip_count;
                    }
                }
            },
            //get the draft skip count
            getDraftSkipCount(){
                let skip_count;
                if(this.selectDraftSend.status === 'draft'){
                    if(this.draft_total == 0 ) {
                        return 0
                    } else {
                        skip_count = this.skip>this.draft_total?this.draft_total:this.skip+1;
                        return skip_count;
                    }
                }
            },
            account() {
                return this.$store.getters.selectedCompany;
            },
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            totalFilters() {
                if(this.receiver_type_selected){
                    this.value_create = 1
                }
                else{
                    this.value_create = 0
                }
                return this.dateRange.length ? 1 || this.value_create || this.author_names_selected.length || this.company_names_selected
                .length || this.call_report_category_selected.length || this.meeting_type_selected.length || this
                .customers_selected.length || this.title_name_selected.length ||  this.location_selected.length || this.receiver_name_selected.length  : this.author_names_selected.length ||
                this.company_names_selected.length || this.call_report_category_selected.length || this
                .meeting_type_selected.length || this.customers_selected.length || this.title_name_selected.length
                || this.location_selected.length || this.receiver_name_selected.length || this.value_create;
            },
            userPermissions(){
                return this.$store.getters.userPermissions;
            }

        },
    };
</script>
<style>

.multiselect.filter-multiple.digi-multiselect .multiselect__tags{
    padding: 0px 31px 0 2px !important
}
.placeholder-text::-webkit-input-placeholder {
	font-size: 13px!important;
}
.dropdown-menu.call-report-type-menu{
    transform: translate3d(-22px, 36px, 0px) !important;
}
.multiselect.digi-multiselect .multiselect__content-wrapper{
    min-width: 130px !important; 
}
@media only screen and (max-width: 510px) {
    .filter-div-absolute {
        width: fit-content !important;
        top: 60px !important;
        overflow: overlay !important;
        left: 24px !important;
    }
}
@media (min-width: 511px) and (max-width: 878px) {
    .filter-div-absolute {
        width: fit-content !important;
        top: 60px !important;
        overflow: overlay !important;
        left: 24px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CallReportList.vue